import { render, staticRenderFns } from "./NewCoupon.vue?vue&type=template&id=1be25894&scoped=true&"
import script from "./NewCoupon.vue?vue&type=script&lang=js&"
export * from "./NewCoupon.vue?vue&type=script&lang=js&"
import style0 from "./NewCoupon.vue?vue&type=style&index=0&id=1be25894&prod&lang=scss&"
import style1 from "./NewCoupon.vue?vue&type=style&index=1&id=1be25894&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be25894",
  null
  
)

export default component.exports